import { render, staticRenderFns } from "./ExtractionTemplateFieldItem.vue?vue&type=template&id=128eae87&scoped=true&"
import script from "./ExtractionTemplateFieldItem.vue?vue&type=script&lang=js&"
export * from "./ExtractionTemplateFieldItem.vue?vue&type=script&lang=js&"
import style0 from "./ExtractionTemplateFieldItem.vue?vue&type=style&index=0&id=128eae87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128eae87",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSelect,VTextField,VTextarea,VTooltip})
